<template>
  <div id="app">
    <!-- <Wxwork v-if="show"></Wxwork> -->
    <!-- <div v-else> -->
    <!--  -->
    <keep-alive :include="$store.state.state.keepAlive">
      <router-view v-if="show">
        <!--这里是会被缓存的视图组件，比如 page1-->
      </router-view>
      <!-- <router-view v-if="!$route.meta.keepAlive" class="Router"></router-view> -->
    </keep-alive>
    <!-- </div> -->
  </div>
</template>

<script>
export default {
  name: "app",
  provide() {
    return {};
  },
  data() {
    return {
      timeFlag: "",
      show: false,  //解决ios注入慢
    };
  },
  created() {
    //在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
    }
    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("pagehide", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
  },
  mounted() {
    var _this = this;
    this.timeFlag = setInterval(() => {
      if (sessionStorage.getItem("ua")) {
        _this.show = true;
      }
    }, 100);
  },
  beforeDestroy() {
    clearInterval(this.timeFlag);
  },
  components: {},
  methods: {},
};
</script>

<style>
</style>
